import React, { use, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Card,
    Fade,
    Grid,
    Table,
    Paper,
    Button,
    Tooltip,
    InputBase,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    CardContent,
    CardActions,
    TableContainer,
    TablePagination,
    tableCellClasses,
} from "@mui/material";
import _, { set } from 'lodash';
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddNewFoundation from "../offcanvas/AddNewFoundation";
import { Search, Folder, EditNote } from "@mui/icons-material";
import GeneralConfirmation from "../forms/GeneralConfirmation";
import SnackBarMessage from "../../components/SnackBarMessage";
import { getItems, searchItem, getStatus, dropOne } from "../repositories/FoundationRepository";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#EC7BA1",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    " &:first-child tr, &:first-child": {
        borderTopLeftRadius: "50px",
    },
    " &:first-child tr, &:last-child": {
        borderTopRightRadius: "50px",
    },
    " &:last-child tr, &:first-child": {
        borderBottomLeftRadius: "50px",
    },
    " &:last-child tr, &:last-child": {
        borderBottomRightRadius: "50px",
    },
}));

const CommonFoundationsEvents = () => {

    const navigate = useNavigate();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const [foundationsList, setFoundationsList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    //modal

    const [openCanvas, setOpenCanvas] = useState(false)
    const [selected, setSelected] = useState([])
    const [isEditing, setIsEditing] = useState()
    const [add, setAdd] = useState()
    const [statusList, setStatusList] = useState([])

    //delete
    const [deleteItem, setDeleteItem] = useState("");
    const [snackOpen, setSnackOpen] = useState(false);
    const [openDelete, setOpenDelete] = useState(false)
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState([])

    const handleDelete = async () => {
        console.log("asd", deleteItem)
        const response = await dropOne(deleteItem);
        if (response.status === "Ok") {
            setSnackSeverity("success");
            setSnackMessage("Se archivó correctamente");
            setSnackOpen(true);
            getData();
        } else {
            setSnackSeverity("error");
            setSnackMessage("No se pudo eliminar");
            setSnackOpen(true);
        }
    };
    //delete

    const onlyClose = () => {
        setOpenCanvas(false)
    }

    const getStatusData = async () => {
        const response = await getStatus();
        if (response) {
            if (response.status === "Ok") {
                setStatusList(response.content);
            } else if (response.status === "401") {
                setStatusList([]);
                navigate(`../error401`);
            } else {
                setStatusList([])
            }
        }
    }

    //modal

    //paginado

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - foundationsList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };


    //termina paginado
    const getData = async () => {
        const response = await getItems();
        if (response) {
            if (response.status === "Ok") {
                setFoundationsList(response.content)
            } else {
                setFoundationsList([])
            }
        }
    }

    //busqueda
    const debouncedSearch = _.debounce(async (searchTerm) => {
        const response = await searchItem(searchTerm);
        if (response) {
            if (response.status === "Ok") {
                setFoundationsList(response.content);
            } else if (response.status === "401") {
                setFoundationsList([]);
                navigate(`../error401`);
            } else {
                setFoundationsList([]);
            }
        }
    }, 800, { leading: true });

    useEffect(() => {
        if (searchTerm === "" || searchTerm === undefined || searchTerm.length === 0) {
            getData();
        } else if (searchTerm.length >= 3) {
            setPage(0);
            debouncedSearch(searchTerm);
            debouncedSearch.cancel();
        }
        getStatusData();
    }, [searchTerm]);

    useEffect(() => {
        getData()
        getStatusData()
    }, []);

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
    };

    //termina busqueda

    return (
        <div>
            <div id="div-style-8">
                <Folder color={"primary"} fontSize="large" id="icon-style-1" />
                <h2>Fundaciones</h2>
            </div>
            <Card id="card-style-2">
                <CardContent>
                    <Grid container spacing={2} id="grid-style-2">
                        <Grid xl={6} lg={8} md={10} sm={12} xs={12}>
                            <Paper component="form" id="paper-style-2">
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Buscar..."
                                    inputProps={{ "aria-label": "search google maps" }}
                                    value={searchTerm}
                                    onChange={handleInputChange}
                                />
                                <IconButton type="button" id="icon-style-2" aria-label="search">
                                    <Search color="primary" />
                                </IconButton>
                            </Paper>
                        </Grid>
                        <Grid xl={6} lg={4} md={2} sm={12} xs={12} id="grid-style-3">
                            <Button
                                component="label"
                                onClick={() => {
                                    setOpenCanvas(true)
                                    setSelected(null)
                                    setAdd(true)
                                    setIsEditing(false)
                                }}
                                variant="contained"
                                color="secondary"
                                size="small"
                                id="button-style-3"
                                style={{ marginRight: "5px" }}
                            >
                                <AddIcon /> Agregar
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid>
                        <TableContainer id="table-container-style-1">
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">No.</StyledTableCell>
                                        <StyledTableCell align="center">Estudio</StyledTableCell>
                                        <StyledTableCell align="center">Ciudad</StyledTableCell>
                                        <StyledTableCell align="center">Tipo de Fundación</StyledTableCell>
                                        <StyledTableCell align="center">Estatus</StyledTableCell>
                                        <StyledTableCell align="center">Acciones</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {foundationsList.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">
                                                Sin registros
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        foundationsList
                                            .slice(
                                                page * rowsPerPage, page * rowsPerPage + rowsPerPage
                                            )
                                            .map((row, index) => {
                                                return (
                                                    <StyledTableRow key={row.id}>
                                                        <StyledTableCell align="center">
                                                            {page * rowsPerPage + index + 1}
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">{`${row?.name} `}</StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            {row?.city}
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            {row?.typeOfFoundation}
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            {row?.status}
                                                        </StyledTableCell>
                                                        <StyledTableCell align="center">
                                                            <Tooltip
                                                                title="Ver"
                                                                TransitionComponent={Fade}
                                                                TransitionProps={{ timeout: 600 }}
                                                                arrow
                                                            >
                                                                <IconButton
                                                                    aria-label="view"
                                                                    size="small"
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        setOpenCanvas(true)
                                                                        setSelected(row)
                                                                        setIsEditing(true)
                                                                        setAdd(true)
                                                                    }}
                                                                >
                                                                    <VisibilityIcon fontSize="medium" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip
                                                                title="Editar"
                                                                TransitionComponent={Fade}
                                                                TransitionProps={{ timeout: 600 }}
                                                                arrow
                                                            >
                                                                <IconButton
                                                                    aria-label="edit"
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={() => {
                                                                        setOpenCanvas(true)
                                                                        setSelected(row)
                                                                        setIsEditing(false)
                                                                        setAdd(false)
                                                                    }}
                                                                >
                                                                    <EditNote fontSize="medium" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip
                                                                title="Eliminar"
                                                                TransitionComponent={Fade}
                                                                TransitionProps={{ timeout: 600 }}
                                                                arrow
                                                            >
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    size="small"
                                                                    color="error"
                                                                    onClick={async () => {
                                                                        setDeleteItem(row?._id);
                                                                        setOpenDelete(true)
                                                                    }}
                                                                >
                                                                    <DeleteIcon fontSize="medium" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                );
                                            })
                                    )}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </CardContent>
                <CardActions>
                    <AddNewFoundation
                        openCanvas={openCanvas}
                        onlyClose={onlyClose}
                        item={selected}
                        isEditing={isEditing}
                        add={add}
                        updatedData={getData}
                        statusData={statusList}
                    />
                    <GeneralConfirmation
                        show={openDelete}
                        agreeText={"Eliminar"}
                        handleClose={() => setOpenDelete(false)}
                        handleSuccess={handleDelete}
                        title={`La fundación "${selected?.name}" se archivará`}
                        subtitle={"¿Desea continuar?"}
                        declinedText={"Cancelar"}

                    />
                    <SnackBarMessage
                        severity={snackSeverity}
                        message={snackMessage}
                        open={snackOpen}
                        onClose={() => {
                            setSnackOpen(false);
                        }}
                    />
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={foundationsList.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelRowsPerPage="Resultados por página:"
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                    />
                </CardActions>
            </Card>

        </div>
    );
};

export default CommonFoundationsEvents;
